import * as React from "react";
import {
  ContentCopy,
  Facebook,
  Share,
  Twitter,
  WhatsApp,
} from "@mui/icons-material";
import { Button, Divider, Drawer } from "@mui/material";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../Redux/Actions/SnackBar";
import copy from "clipboard-copy";
import {
  TwitterShareButton,
  FacebookShareButton,
  WhatsappShareButton,
} from "react-share";

const ShareLink = ({ url, variantName, variantImage }) => {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
 
const copyToClipboard = (text) => {
  copy(text).then(() => {
     dispatch(
       setSnackbar({
         open: true,
         message: "Copied to clipboard",
         vaiant: "success",
       })
     );
  });
};

  return (
    <>
      <Button
        size="small"
        endIcon={<Share className="!text-lg" />}
        className="!capitalize"
        onClick={handleClickOpen}
      >
        Share
      </Button>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={handleClose}
        PaperProps={{ className: "!rounded-t-lg !h-[30vh]" }}
      >
        <span className="flex justify-center p-2" onClick={handleClose}>
          <span className="h-[5px] w-24 rounded-full bg-zinc-200 dark:bg-zinc-700"></span>
        </span>
        <span className="flex items-center p-4 gap-3">
          <img src={variantImage} alt="" className="h-14 w-14 rounded" />
          <span className="flex flex-col gap-1">
            <p className="text-sm font-semibold">{variantName}</p>
            <p className="text-xs">{url}</p>
          </span>
        </span>
        <Divider />
        <span className="flex gap-4 items-center justify-center p-3">
          <span
            className="shadow items-center flex flex-col p-3 rounded-sm gap-1 w-[80px]"
            onClick={() => copyToClipboard(url)}
          >
            <ContentCopy className="!text-xl" />
            <p className="text-xs">Copy Link</p>
          </span>
          <WhatsappShareButton url={url}>
            <span className="shadow items-center flex flex-col p-3 rounded-sm gap-1 w-[80px]">
              <WhatsApp className="!text-xl text-[#00a884]" />
              <p className="text-xs">WhatsApp</p>
            </span>
          </WhatsappShareButton>
          <FacebookShareButton url={url}>
            <span className="shadow items-center flex flex-col p-3 rounded-sm gap-1 w-[80px]">
              <Facebook className="!text-xl text-[#1877F2]" />
              <p className="text-xs">Facebook</p>
            </span>
          </FacebookShareButton>
          <TwitterShareButton url={url}>
            <span className="shadow items-center flex flex-col p-3 rounded-sm gap-1 w-[80px]">
              <Twitter className="!text-xl text-[#1CA1F2]" />
              <p className="text-xs">Twitter</p>
            </span>
          </TwitterShareButton>
        </span>
        <Divider />
      </Drawer>
    </>
  );
};
export default ShareLink;
